<template>
    <div class="box white p-3">
        <K2Row space-between="true" class="border-bottom mb-4">
            <K2Text bold="true" class-name="mb-3" :style="{fontSize:uiVariable.fontSize.lg}">
                {{lang("Select Development Goals")}}
            </K2Text>
            <K2Row>
                <div v-b-toggle="'goal'">
                    <K2Icon color="black" name="expand_less" class="when-open"/>
                    <K2Icon color="black" name="expand_more" class="when-closed"/>
                </div>
            </K2Row>
        </K2Row>
        <b-collapse id="goal" visible>
            <div class="row" style="min-height: 200px">
                <K2Row>
                    <div class="informationContentEach  flex-grow-1 me-2">
                        <el-select v-model="porDevelopmentDomain" :placeholder="lang('Select Development Goals')"
                                   class="pro-edt-select w-100"
                                   @change="handleIndicator(porDevelopmentDomain)">
                            <el-option
                                    v-for="(item, index) in porDevelopmentDomainList"
                                    :key="index"
                                    :label="item.Str_SortBy"
                                    :value="item.Str_SortBy">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="informationContentEach flex-grow-1 me-2">
                        <el-select v-model="porDevelopmentIndicator" :placeholder="lang('Select Indicator')"
                                   class="pro-edt-select w-100">
                            <el-option
                                    v-for="(item, index) in porDevelopmentIndicatorList"
                                    :key="item.PlnMasIndicator"
                                    :label="item.PlnMasIndicator"
                                    :value="item.PlnMasIndicator">
                            </el-option>
                        </el-select>
                    </div>
                    <K2Button @onclick="setValidateDropdown()" theme="2">{{lang("Add")}}</K2Button>
                </K2Row>
                <div v-if="porDevelopmentObject.length>0" class="col-md-12 formDiv mt-3 m-md-3 p-0 px-3 px-md-0">
                    <label>{{lang("You have selected")}}</label>
                    <div class="responsive-table customScroll">
                        <table class="w-100">
                            <thead class="table-thead">
                            <tr class="table-tr">
                                <th class="table-th">{{ lang("Domain") }}</th>
                                <!--              <th class="table-th">{{ lang("Goals") }}</th>-->
                                <th class="table-th">{{ lang("Indicator") }}</th>
                                <th class="table-th text-center">{{lang("Termly Report")}}</th>
                                <th class="table-th">{{lang("Remarks")}}</th>
                                <th class="table-th text-center">{{ lang("Action") }}</th>
                            </tr>
                            </thead>
                            <tr v-for="(porDevelopmentObjectValueInfo, index) in porDevelopmentObject"
                                style="border-bottom: 1px solid #e4e7ed;text-align: left;">
                                <td class="table-td">{{ porDevelopmentObjectValueInfo.Domain }}</td>
                                <!--              <td class="table-td">{{ porDevelopmentObjectValueInfo.Goals }}</td>-->
                                <td class="table-td"><input type="text" class="form-control" readonly
                                                            :value="porDevelopmentObjectValueInfo.Indicator"
                                                            style="margin: 0px;"/></td>
                                <td class="table-td text-center">
                                    <el-checkbox v-model="porDevelopmentObjectValueInfo.termlyReport"
                                                 class="text-center"/>
                                </td>
                                <td class="table-td">
                                    <K2Row space-between="true" v-if="porDevelopmentObjectValueInfo.remarks"
                                           align="center" class="ms-3">
                                        <K2Text v-if="porDevelopmentObjectValueInfo.remarks && porDevelopmentObjectValueInfo.remarks.length > 15">
                                            {{porDevelopmentObjectValueInfo.remarks.substring(0,15)}}...
                                        </K2Text>
                                        <K2Text v-else>
                                            {{porDevelopmentObjectValueInfo.remarks}}
                                        </K2Text>
                                        <el-button @click="addRemarks(porDevelopmentObjectValueInfo)" size="small">
                                            {{lang("Edit")}}
                                        </el-button>
                                    </K2Row>
                                    <el-button @click="addRemarks(porDevelopmentObjectValueInfo)" size="small" v-else>
                                        {{lang("Add")}}
                                    </el-button>
                                </td>
                                <td class="table-td py-2 px-3 text-center">
                                    <K2Row justify_content="center">
                                        <K2Confirm title="Are you sure you want to delete this post?" :hideCancel="true"
                                                   class="me-2"
                                                   :background="uiVariable.color.backgroundGrey2"
                                                   :color="uiVariable.color.purple"
                                                   :label="lang('View')">
                                            <div class="p-3">
                                                <div class="mb-2">
                                                    <K2Text bold="true">{{lang("Domain")}}:</K2Text>
                                                    <br/>
                                                    <K2Text>{{ porDevelopmentObjectValueInfo.Domain }}</K2Text>
                                                </div>
                                                <div class="mb-2">
                                                    <K2Text bold="true">{{lang("Goals")}}:</K2Text>
                                                    <br/>
                                                    <K2Text>{{ porDevelopmentObjectValueInfo.Goals }}</K2Text>
                                                </div>
                                                <div class="mb-2">
                                                    <K2Text bold="true">{{lang("Indicator")}}:</K2Text>
                                                    <br/>
                                                    <K2Text>{{ porDevelopmentObjectValueInfo.Indicator }}</K2Text>
                                                </div>
                                            </div>
                                        </K2Confirm>
                                        <K2Button theme="2" @onclick="removeSelectedGoals(index)" size="small"
                                                  :background="uiVariable.color.button1">
                                            <K2Text color="white">{{lang("Delete")}}</K2Text>
                                        </K2Button>
                                    </K2Row>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>
    import K2Icon from "../../../uiComponents/k2Icon/k2MAIcon";
    import K2Row from "../../../uiComponents/k2Row/k2Row";
    import uiVariable from "../../../config/uiVariable";
    import K2Button from "../../../uiComponents/k2Button/k2Button";
    import K2Text from "../../../uiComponents/k2Text/k2Text";
    import Cookies from "js-cookie";
    import {lang} from "../../../locale";
    import K2ToolTip from "../../../uiComponents/k2ToolTip/k2ToolTip";
    import K2Confirm from "../../../uiComponents/k2Confirm/k2Confirm";

    export default {
        name: "activityGoal",
        components: {K2Confirm, K2ToolTip, K2Text, K2Button, K2Row, K2Icon},
        props: ["handleBack", "mselectedstudents", "misselectedclasses", "goalsList", "obj_Post", "porDevelopmentDomainList", "loadDomainList", "tselectedGoals"],
        watch: {
            tselectedGoals: function (value) { // watch it
                if (value) {
                    this.porDevelopmentObject = value;
                }
            },
        },
        data() {
            return {
                uiVariable: uiVariable,
                ddlDomain: '',
                ddlLearningMomentsList: [],
                ddlIndicator: '',
                ddlSchool: '',
                selectedLearningMomentsListInt: [],
                child_obj_Post: {
                    PostID: "",
                    PostPorDtlTitle: "",
                    PostPorDtlObservation: "",
                    PostPorDtlAnalysisReflection: "",
                    PostPorDtlDevelopmentGoals: []
                },
                ddlGoalList: [],
                indicatorList: [],
                porDevelopmentObject: [],
                arr_indicatorList: [],
                ddlGoalsList: [],
                porDevelopmentDomain: "",
                porDevelopmentIndicator: "",
                porDevelopmentIndicatorList: [],
                selectedLearningMomentsList: [{
                    prop: "PlnMasDomain",
                    label: lang("Domain")
                },
                    // {
                    //   prop: "PlnMasGoals",
                    //   label: "Goals"
                    // },
                    {
                        prop: "PlnMasIndicator",
                        label: lang("Indicator")
                    }],
            };
        },
        mounted() {
            this.init();
            const self = this;
        },
        methods: {
            lang,
            async init() {
                this.child_obj_Post = this.obj_Post;
                this.ddlSchool = Cookies.get('schoolSession');
            },
            showLoading() {
                this.$vs.loading();
            },
            hideLoading() {
                this.$vs.loading.close();
            },
            handleIndicator(value) {
                this.porDevelopmentIndicatorList = [];

                this.porDevelopmentDomainList.forEach(item => {
                    if (item.Str_SortBy === value) {
                        this.porDevelopmentIndicatorList = item.ArrObj_Items;
                    }
                });

            },
            removeIndicator(row) {
                this.selectedLearningMomentsListInt = this.selectedLearningMomentsListInt.filter(m2 => m2.PlnMasIndicator !== row.PlnMasIndicator);
            },
            setValidateDropdown() {
                if (this.porDevelopmentIndicator !== "") {
                    if (!this.arr_indicatorList.includes(this.porDevelopmentIndicator)) {
                        this.arr_indicatorList.push(this.porDevelopmentIndicator);
                    }
                }
                // this.porDevelopmentObject = [];
                this.obj_Post.PostPorDtlAnalysisReflection = "";

                this.goalsList.forEach(m => {

                    if (this.porDevelopmentIndicator === m.PlnMasIndicator) {
                        let porDevelopmentObjectTemp = {
                            Domain: m.PlnMasDomain,
                            Goals: m.PlnMasGoalsITL,
                            Indicator: m.PlnMasIndicator,
                            KeyId: m.KeyId,
                        };
                        this.porDevelopmentObject.push(porDevelopmentObjectTemp);

                        this.obj_Post.PostPorDtlAnalysisReflection += m.PlnMasIndicator + '\n';
                    }
                });

                this.porDevelopmentDomain = "";
                this.porDevelopmentIndicator = "";
                this.porDevelopmentIndicatorList = [];
                this.$emit("loadDomainList", this.porDevelopmentObject);
            },
            setAnalysisValue(event, objIndex) {

                let editedText = "";
                if (!this.isNull(event)) {
                    editedText = event.target.value;
                }

                this.child_obj_Post.PostPorDtlAnalysisReflection = "";

                this.porDevelopmentObject.forEach((val, index) => {
                    if (objIndex !== "" && index === objIndex && val.Indicator !== editedText) {
                        val.Indicator = editedText;

                        this.arr_indicatorList[objIndex] = editedText;

                        let porDevelopmentObjectTemp = {
                            PlnMasDomain: val.Domain,
                            PlnMasGoals: val.Goals,
                            PlnMasIndicator: val.Indicator,
                            Included: "No",
                            KeyId: (this.ddlGoalsList.length + 1),
                        };

                        this.ddlGoalsList.push(porDevelopmentObjectTemp);
                    }
                    this.child_obj_Post.PostPorDtlAnalysisReflection += val.Indicator + '\n';
                });

                this.setValidateDropdown();
            },
            removeSelectedGoals(itemValue, itemIndex) {
                this.porDevelopmentObject.splice(itemIndex, 1);

                this.goalsList.forEach((d, dIndex) => {
                    if (itemValue.KeyId === d.KeyId) {
                        this.porDevelopmentObject = this.porDevelopmentObject.filter((indicator, iIndex) => {
                            return indicator.Indicator !== d.PlnMasIndicator;
                        });
                    }
                });
                this.setValidateDropdown(this.goalsList);
            },
            addRemarks(item) {
                this.$prompt(lang("Please input your remarks"), lang("Remarks"), {
                    confirmButtonText: lang("OK"),
                    cancelButtonText: lang("Cancel"),
                    inputValue: item.remarks
                }).then(({value}) => {
                    item.remarks = value;
                    this.$forceUpdate();
                }).catch(() => {

                });
            }
        },

    };
</script>